import './EquipmentHistoryList.scss';
import React, { useState, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import EquipmentLoadLogItem from '../EquipmentLoadLogItem';
import { GetEquipmentLoggers_getEquipmentLoggers as LoadLogger } from '../../../../types/schemaTypes';

interface EquipmentHistoryListProps {
    loadLoggers: LoadLogger[];
    searchPhrase: string;
}

const EquipmentHistoryList = ({ loadLoggers, searchPhrase }: EquipmentHistoryListProps): React.ReactElement => {
    const [filteredLoadLoggers, setFilteredLoadLoggers] = useState(loadLoggers);

    useEffect(() => {
        const result = loadLoggers.filter((load: LoadLogger) => {
            return (
                load.message.toLowerCase().includes(searchPhrase.toLowerCase()) ||
                (load.creatorName && load.creatorName.toLowerCase().includes(searchPhrase.toLowerCase())) ||
                (load.systemType && load.systemType.toLowerCase().includes(searchPhrase.toLowerCase()))
            );
        });
        setFilteredLoadLoggers(result);
    }, [loadLoggers, searchPhrase]);

    return (
        <div className="EquipmentHistoryList-ListContainer">
            <div className="EquipmentHistoryList-RowContainer LoadHistory-EquipmentHistoryList">
                <Col md={3} className="EquipmentHistoryList-HeaderColumn">
                    Date
                </Col>
                <Col md={5} className="EquipmentHistoryList-HeaderColumn">
                    Log
                </Col>
                <Col md={2} className="EquipmentHistoryList-HeaderColumn">
                    User
                </Col>
                <Col md={2} className="EquipmentHistoryList-HeaderColumn">
                    System Type
                </Col>
            </div>
            {filteredLoadLoggers.map((item, index) => (
                <EquipmentLoadLogItem key={item.id} loadLogItem={item} index={index} />
            ))}
        </div>
    );
};

export default EquipmentHistoryList;

